module.exports = __webpack_public_path__ + "ac2a19c0da92a7fdee7338b36dff1d72.MP3";